import React, { PureComponent } from 'react';
import * as Sentry from '@sentry/browser';
import { connect } from 'react-redux';
import Config from 'app/config';
import { Text, toast } from '@acast/decibel';
import PendingPage from 'shared/components/pending-page';
import Modal from 'shared/components/modal';
import ContentContainer from 'shared/components/content-container';
import Features from 'app/features';
import { fetchShows, selectShows } from 'ducks/shows';
import { selectHasShows, selectHasFeature } from 'ducks/user';
import FirstTimeOverview from './first-time-overview';
import OverviewShows from './overview-shows';
import Navigation from './Navigation';

const MODAL_ID = 'overview/unauthorized';

const deriveStateFromProps = ({ hasShows, isAllowedToCreateShow }, { isLoading }) => {
  const shouldDisplayModal = !isLoading && !hasShows && !isAllowedToCreateShow;

  return { shouldDisplayModal, isLoading };
};

class OverviewPage extends PureComponent {
  constructor(props) {
    super(props);

    const state = { isLoading: true };
    this.state = {
      ...state,
      ...deriveStateFromProps(props, state),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(deriveStateFromProps(nextProps, this.state));
  }

  componentDidUpdate(prevProps, prevState) {
    const { shouldDisplayModal } = this.state;
    if (shouldDisplayModal && shouldDisplayModal !== prevState.shouldDisplayModal) {
      this.presentModal();
    }
  }

  componentDidMount() {
    if (this.state.shouldDisplayModal) {
      this.presentModal();
    }

    this.props
      .fetchShows()
      .then(() => {
        this.setIsLoading(false);
      })
      .catch(error => {
        toast.danger(`Error fetching shows: ${error.message}`, { closable: true });
        Sentry.captureException(error);
        this.setIsLoading(false);
      });
  }

  componentWillUnmount() {
    if (this.state.shouldDisplayModal) {
      Modal.dismiss(MODAL_ID);
    }
  }

  presentModal() {
    Modal.present({
      id: MODAL_ID,
      title: 'Something went wrong.',
      dialog:
        "It seems like you don't have the permissions to access Create. Please contact our support.",
      actions: [{ name: 'Contact Support', value: 'contact' }],
    }).then(action => {
      if (action === 'contact') {
        window.location.assign(
          `mailto:${Config.get('ACAST_SUPPORT_EMAIL')}?Subject=Unable%20to%20access%20Create`
        );
      }
    });
  }

  renderBody() {
    const { shows } = this.props;
    if (this.state.isLoading) {
      return <PendingPage />;
    }

    if (this.props.hasShows) {
      return (
        <>
          <Text variant="h1">Overview</Text>
          <OverviewShows
            shows={shows}
            isAllowedToCreateNewShow={this.props.isAllowedToCreateShow}
          />
        </>
      );
    }

    if (this.props.isAllowedToCreateShow) {
      return <FirstTimeOverview />;
    }

    return null;
  }

  setIsLoading = isLoading => {
    this.setState(deriveStateFromProps(this.props, { isLoading }));
  };

  render() {
    return (
      <>
        <Navigation />
        <ContentContainer>{this.renderBody()}</ContentContainer>
      </>
    );
  }
}

const hasAllowUnlimitedChannels = selectHasFeature(Features.AllowUnlimitedChannels);
export default connect(
  state => ({
    hasShows: selectHasShows(state),
    isAllowedToCreateShow: hasAllowUnlimitedChannels(state),
    shows: selectShows(state),
  }),
  { fetchShows }
)(OverviewPage);
